import { Alert } from "@origin-digital/ods-core";
import * as React from "react";

const UpdatePremiseAlert: React.FC<{ isPremise?: boolean }> = ({
  isPremise,
}) => {
  return (
    <Alert tone="caution">
      {isPremise
        ? "Save updates to Premises and then fill out customer Account details below."
        : "Save updates to Premises first."}
    </Alert>
  );
};

export default UpdatePremiseAlert;
